import React from "react";
import classes from "./Link.module.scss";

export type Props = {
  label: string;
  suffix?: string;
  onClick: () => void;
};

const Link = (props: Props) => {
  return (
    <div className={classes.container}>
      <div className={classes.link} onClick={props.onClick}>
        {props.label}
      </div>
      {props.suffix && <div className={classes.suffix}>{props.suffix}</div>}
    </div>
  );
};

export default Link;
